<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre7">
<br class="calibre9" id="calibre_pb_3"/> </p>
<p class="calibre7"> <span class="calibre4"> </span> </p>
<p class="calibre7"> <span class="calibre4">Acknowledgements</span> </p>
<p class="calibre7"> <span class="calibre4"> </span> </p>
<p class="calibre14"> <span class="calibre15">This book is dedicated to Sandy, who keeps me grounded.  Thank you for standing by me, I love you. </span> </p>
<p class="calibre7"> <span class="calibre15"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre8" id="calibre_pb_4"></span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_002.vue?eae9fc34